// src/components/StructuredData.jsx
// Injects Schema.org "LocalBusiness" structured data (JSON-LD) into <head>.
// Uses the same live business info (phone/email/address) that Admin →
// Social Details already controls, so this stays in sync automatically
// instead of being hardcoded and going stale.
import { useEffect } from "react";
import { useSocialDetails } from "../hooks/useSocialDetails";

const SITE_URL = "https://www.circuitprinting.com";

export default function StructuredData() {
  const { data: sd, loading } = useSocialDetails();

  useEffect(() => {
    if (loading) return; // wait for real data before publishing the schema

    const schema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": sd.name || "Circuit Printing Solutions",
      "image": `${SITE_URL}/logo.jpeg`,
      "url": SITE_URL,
      "telephone": sd.phone || undefined,
      "email": sd.email || undefined,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": sd.address || undefined,
        "addressLocality": sd.city || undefined,
        "addressRegion": sd.state || undefined,
        "postalCode": sd.postcode || undefined,
        "addressCountry": sd.country || "CA",
      },
      "priceRange": "$$",
    };

    // Strip any fields that aren't set yet, so we don't publish empty/placeholder values
    Object.keys(schema).forEach((key) => schema[key] === undefined && delete schema[key]);
    Object.keys(schema.address).forEach((key) => schema.address[key] === undefined && delete schema.address[key]);

    let script = document.getElementById("ld-json-localbusiness");
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "ld-json-localbusiness";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);
  }, [sd, loading]);

  return null;
}
